import api from '@services/api';
import { AttachmentRequest, PeriodRequest, PeriodsResponse } from '../models/period';

/**
 * <p>
 * API endpoints that cover all period related CRUD calls
 */
export const periodApi = api.injectEndpoints({
  endpoints: (builder) => ({
    periods: builder.query<PeriodsResponse[], PeriodRequest | void>({
      query: (input?: PeriodRequest) => ({
        url: encodeURI(`/report/period/list${input?.date ? `?year=${input.date}` : ''}`),
      }),
      providesTags: ['Periods'],
    }),
    years: builder.query<string[], void>({
      query: () => ({
        url: encodeURI(`/report/period/years/list`),
      }),
      providesTags: ['Periods'],
    }),
    uploadAttachmentFile: builder.mutation<void, AttachmentRequest>({
      query: (formData: AttachmentRequest) => ({
        url: encodeURI(`/report/financial-report/upload?period=${formData.date}`),
        method: 'POST',
        body: formData.formData,
      }),
      invalidatesTags: ['Periods'],
    }),
    closePeriod: builder.mutation<void, string>({
      query: (date: string) => ({
        url: encodeURI(`/report/period/close?period=${date}`),
        method: 'POST',
      }),
      invalidatesTags: ['Periods'],
    }),
    openPeriod: builder.mutation<void, string>({
      query: (date: string) => ({
        url: encodeURI(`/report/period/open?period=${date}`),
        method: 'POST',
      }),
      invalidatesTags: ['Periods'],
    }),
    uploadReasonFile: builder.mutation<void, AttachmentRequest>({
      query: (formData: AttachmentRequest) => ({
        url: encodeURI(`/report/financial-data/upload?period=${formData.date}`),
        method: 'POST',
        body: formData.formData,
      }),
      invalidatesTags: ['Periods'],
    }),
    uploadTranspSpreadSheetFile: builder.mutation<void, AttachmentRequest>({
      query: (formData: AttachmentRequest) => ({
        url: encodeURI(`/report/financial-data/uploadTransport?period=${formData.date}`),
        method: 'POST',
        body: formData.formData,
      }),
      invalidatesTags: ['Periods'],
    }),
    process: builder.mutation<void, string>({
      query: (data: string) => ({
        url: encodeURI(`/report/financial-detail/process?period=${data}`),
        method: 'POST',
      }),
      invalidatesTags: ['Periods'],
    }),
  }),
});

export const {
  usePeriodsQuery,
  useYearsQuery,
  useUploadAttachmentFileMutation,
  useClosePeriodMutation,
  useOpenPeriodMutation,
  useUploadReasonFileMutation,
  useUploadTranspSpreadSheetFileMutation,
  useProcessMutation,
} = periodApi;
